/** Units of measure, conversion rules, and the server-side conversion preview. */
import { z } from 'zod';
import { uomDimensionSchema } from './enums.js';
import { decimalIn, decimalOut, readableSchema, uuidSchema } from './primitives.js';
export const uomSchema = readableSchema.extend({
    code: z.string(),
    name: z.string(),
    dimension: uomDimensionSchema,
    /** How many decimals this unit is meaningfully divisible into. Drives quantity display. */
    decimal_places: z.number().int(),
    is_active: z.boolean(),
});
export const uomCreateSchema = z.object({
    code: z.string().min(1).max(20),
    name: z.string().min(1).max(80),
    dimension: uomDimensionSchema.default('COUNT'),
    decimal_places: z.number().int().min(0).max(6).default(4),
    is_active: z.boolean().default(true),
});
export const uomConversionSchema = readableSchema.extend({
    from_uom_id: uuidSchema,
    to_uom_id: uuidSchema,
    factor: decimalOut,
    /** An item-specific override. Beats the global rule for that item. */
    item_id: uuidSchema.nullable().default(null),
});
export const uomConversionCreateSchema = z
    .object({
    from_uom_id: uuidSchema,
    to_uom_id: uuidSchema,
    factor: decimalIn({ gt: '0', maxPlaces: 6, label: 'factor' }),
    item_id: uuidSchema.nullish(),
})
    .refine((v) => v.from_uom_id !== v.to_uom_id, {
    message: 'a conversion must be between two different units',
    path: ['to_uom_id'],
});
/**
 * The result of `GET /v1/uoms/convert`.
 *
 * This endpoint exists so the number a picker sees and the number the ledger applies are
 * the same number. Multiplying factors in the browser is how a scanned case becomes one
 * unit — chains compose (1 CASE = 4 BOX = 48 NOS) and the server rounds once at the end,
 * not per hop. A skin must never do this arithmetic itself.
 */
export const conversionPreviewSchema = z.object({
    quantity: decimalOut,
    from_uom: z.string(),
    to_uom: z.string(),
    converted: decimalOut,
});
//# sourceMappingURL=uom.js.map